<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <h4 class="text-center">Liquidación a proveedor</h4>
        <div>
          <router-link class="btn-link pull-right" to="/liquidaciones/proveedores">Volver a la lista</router-link>
        </div>
      </div>
      <div class="row">
        <div class="panel">
          <div class="panel-body">
            <div class="col-xs-12 col-sm-4">
              <div class="form-group">
                <label for="">Empresa</label>
                <combo-proveedores v-model="empresa"></combo-proveedores>
                <span class="label label-danger" v-if="!$v.empresa.required && mostrarErrores">Debe seleccionar una empresa</span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-1">
              <div class="form-group">
                <label for="">Comisión</label>
                <input class="form-control" type="number" name="" v-model="comision" min="0" max="100">
              </div>
            </div>
            <div class="col-xs-12 col-sm-6">
              <div class="col-xs-6">
                  <div class="form-group">
                    <label for="">Desde</label>
                    <date-picker v-model="filtros.desde"></date-picker>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="form-group">
                    <label for="">Hasta</label>
                    <date-picker v-model="filtros.hasta"></date-picker>
                  </div>
                </div>
            </div>
              <div class="col-xs-12 col-sm-1">
                <div class="form-group">
                  <button style="margin-top:20px" class="btn pull-right btn-fill" @click="changeProveedor">
                      Aplicar
                  </button>
                </div>
              </div>
          </div>
          <div class="panel-body">
                <div class="col-xs-12 col-sm-4">
                  <div class="form-group">
                    <label for="">Liquidación</label>
                    <select ref="slLiquidaciones" id="" v-model="liquidacion" class="form-control select2" style="width: 100%;">
                      <option value="">Nueva liquidación</option>
                      <option v-for="liquidacion in liquidaciones" :value="liquidacion._id" :key="liquidacion._id">{{liquidacion.numero}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-4" v-if="sucursales.length > 0">
                  <div class="form-group">
                    <label for="">Cliente</label>
                    <select v-model="filtros.sucursal" id="" class="form-control">
                      <option value="-1">Todos</option>
                      <option :value="sucursal._id" :key="sucursal._id" v-for="sucursal in sucursales">{{sucursal.empresa.razonSocial}}-{{sucursal.denominacion}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-4" v-if="filtros.sucursal !== '-1'">
                  <div class="form-group">
                    <label for="">Combo</label>
                    <select v-model="filtros.combo" id="" class="form-control">
                      <option value="-1">Todos</option>
                      <option :value="combo._id" :key="combo._id" v-for="combo in combosFiltrados">{{combo.nombre}}</option>
                    </select>
                  </div>
                </div>
          </div>
          <div class="panel-footer">
            <div class="text-center center-block">
              <button class="btn btn-fill" @click="clickLiquidar">
                <template v-if="!liquidacion">Crear liquidación</template>
                <template v-else>Agregar entregas a liquidación</template>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <table class="table">
          <thead>
            <tr>
              <th>
                <button class="btn btn-fill btn-xs" @click="seleccionarTodos"><i class="fa fa-check"></i></button>
              </th>
              <th>Número</th>
              <th>Fecha</th>
              <th>Usuario</th>
              <th>Combo</th>
              <th>Monto</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="entrega, a in entregasFiltradas">
              <tr>
                <td>
                  <div class="smart-form">
                    <label class="checkbox">
                      <input type="checkbox" :id="'selectable' + a" class="selectable" v-model="entrega.seleccionada" >
                      <i></i>
                    </label>
                  </div>
                </td>
                <td>{{entrega.numero}}</td>
                <td>{{entrega.fechaEntrega | formatFecha}}</td>
                <td>{{entrega.usuario.displayName}}-<b>{{entrega.sucursal.empresa.razonSocial}} {{entrega.sucursal.denominacion}}</b></td>
                <td v-if="entrega.combo">{{entrega.combo.nombre}}</td>
                <td v-else></td>
                <td>{{entrega.montoBruto | formatMoneda}}</td>
                <td>{{entrega.estado}}</td>
                <td>
                    <button class="btn btn-link btn-xs" @click="entrega.verDetalle = !entrega.verDetalle">Ver detalle</button>
                </td>
              </tr>
              <tr v-if="entrega.verDetalle">
                <td colspan="5">
                  <table class="table table-bordered">
                    <tbody>
                      <tr v-for="plato in entrega.platos">
                        <td class="text-right">{{plato.cantidad}}x</td>
                        <td colspan="3">{{plato.plato.nombre}}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
import DatePicker from '../Shared/DatePicker'
import ComboProveedores from '../Shared/ComboProveedores'
import $ from 'jquery'
import './../../assets/css/select2.css'
import 'select2'
import moment from 'moment'
import {sortBy} from 'lodash'
import {required, minLength} from 'vuelidate/lib/validators'
import 'sweetalert2/dist/sweetalert2.css'
import swal from 'sweetalert2'
export default {
  components: {
    'combo-proveedores': ComboProveedores,
    'date-picker': DatePicker
  },
  filters: {
    formatFecha (value) {
      return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
    },
    formatMoneda (value) {
      return '$' + parseFloat(value).toFixed(2)
    }
  },
  validations: {
    empresa: {
      required
    },
    entregas: {
      required,
      minLength: minLength(1)
    }
  },
  data () {
    return {
      loading: false,
      comision: 10,
      empresa: null,
      entregas: [],
      liquidacion: null,
      liquidaciones: [],
      precios: [],
      sucursales: [],
      valorCambiar: false,
      mostrarErrores: true,
      filtros: {
        desde: null,
        hasta: null,
        sucursal: '-1',
        combo: '-1'
      }
    }
  },
  computed: {
    combosFiltrados () {
      const me = this
      let ids = me.precios.map((precio) => {
        return precio.combo._id
      })
      let combos = me.combos.filter((combo) => {
        return ids.includes(combo._id)
      })
      return combos
    },
    entregasFiltradas () {
      const me = this
      let entregas = me.entregas
      me.cambiarSeleccion(false)
      if (me.filtros.combo !== '-1') {
        entregas = entregas.filter((entrega) => {
          return entrega.combo._id === me.filtros.combo
        })
      }
      return sortBy(entregas, 'fechaEntrega')
    },
    entregasSeleccionadas () {
      const me = this
      return me.entregasFiltradas.filter((entrega) => {
        return entrega.seleccionada
      })
    }
  },
  methods: {
    cambiarSeleccion (valor) {
      const me = this
      me.entregas.forEach((entrega) => {
        entrega.seleccionada = valor
      })
    },
    changeProveedor () {
      const me = this
      if (me.empresa === '-1' || !me.filtros.desde || !me.filtros.hasta) {
        return []
      }
      me.precios = []
      me.entregas = []
      let filters = { idEmpresa: this.empresa, desde: me.filtros.desde, hasta: me.filtros.hasta, sucursal: me.filtros.sucursal }
      me.$emit('activar-modal')
      me.$http.post('/api/admin/liquidaciones/abiertasproveedor', filters).then(({body}) => {
        // console.log(body)
        me.liquidaciones = body.liquidaciones
        let entregas = body.entregas
        me.sucursales = body.sucursales
        entregas.forEach((entrega) => {
          entrega.seleccionada = false
          entrega.verDetalle = false
        })
        me.entregas = entregas
        me.precios = body.precios
        me.combos = body.combos
      }, (err) => {
        console.error(err)
        me.$emit('cerrar-modal')
      }).then(() => {
        me.$emit('cerrar-modal')
        $(me.$refs.slLiquidaciones).select2({
          selectOnClose: true
        }).on('change', (e) => {
          me.liquidacion = me.$refs.slLiquidaciones.value
        })
      })
    },
    clickLiquidar () {
      const me = this
      swal({
        title: 'Crear liquidación',
        text: '¿Desea crear la liquidación?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, crear',
        cancelButtonText: 'No, cerrar esta ventana'
      }).then(() => {
        me.generarLiquidacion()
      }, (dismiss) => {
        return false
      })
    },
    generarLiquidacion () {
      const me = this
      if (me.$v.$invalid) {
        me.mostrarErrores = true
        return false
      }
      me.$emit('activar-modal')
      let ids = me.entregasSeleccionadas.map((entrega) => {
        return entrega._id
      })
      me.$http.post('/api/admin/liquidaciones/proveedor', {
        ids: ids,
        idEmpresa: me.empresa,
        comision: me.comision,
        idLiquidacion: me.liquidacion
      }).then(({body}) => {
        me.$emit('mostrar-notificacion', 'La operación se ha realizado correctamente', 'success')
        me.entregas = me.entregas.filter((entrega) => {
          return !ids.includes(entrega._id)
        })
        if (body._id) {
          me.liquidaciones.push({
            numero: body.numero,
            fechaCreacion: body.fechaCreacion,
            _id: body._id
          })
          me.liquidacion = body._id
        }
      }, (err) => {
        console.error(err)
      }).then(() => {
        me.$emit('cerrar-modal')
      })
    },
    seleccionarTodos () {
      console.log('seleccionarTodos')
      const me = this
      me.valorCambiar = !me.valorCambiar
      me.cambiarSeleccion(me.valorCambiar)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormProveedores.vue?73bd4a3f